import { ID } from '@/models/common';

const PATHS = {
	AUTH: {
		ME: '/api/auth/me',
		LOGIN: '/api/auth/login',
		LOGOUT: '/api/auth/logout',
		SIGNUP: '/api/auth/signup',
		CALLBACK: '/api/auth/callback',
	},
	API: {
		ACCESS_TOKEN: '/api/accessToken',
	},
	HOME: {
		ROOT: '/',
	},
	VRF: {
		ROOT: '/dvrf',
		CREATE_SUBSCRIPTION: '/dvrf/create-subscription',
		SUBSCRITPION_MANAGER: 'dvrf/subscription-manager',
	},
	CATALOG: {
		ROOT: '/',
		DETAILS: (query: any): string => `/details${query}`,
	},
	INDICES: {
		ROOT: '/indices',
		DETAILS: (query: any): string => `/indices/details${query}`,
	},
	VALIDATORS: {
		ROOT: '/validators',
		DETAILS: (query: any): string => `/validators/details${query}`,
	},
	NETWORKS: {
		ROOT: (networkType?: string, network?: string, version?: string | number | null | undefined): string =>
			networkType
				? `/networks?networkType=${networkType}&network=${network}`
				: `/networks?networkType=mainnet&network=pull`,
		DETAILS: (name: string, id: string, networkType?: string, network?: string, version?: string): string =>
			networkType
				? `/networks/${name}?nid=${id}&networkType=${networkType}&network=${network}`
				: `/networks/${name}?nid=${id}&network-${network}`,
		INSTRUMENT_DETAILS: (
			id: ID,
			networkSlug: string,
			instrumentId: ID,
			version?: string | number | null | undefined
		): string => `/networks/${networkSlug}/${instrumentId}?nid=${id}`,
	},
	PROVIDER: {
		ROOT: '/providers',
		DETAILS: (query: any): string => `/providers/details${query}`,
	},
	TESTNET: {
		ROOT: '/testnet',
		DETAILS: (id: string): string => `/testnet/?id=${id}`,
	},
};

export default PATHS;
